import { render, staticRenderFns } from "./admin_accordion.vue?vue&type=template&id=0aab0efd&scoped=true&"
import script from "./admin_accordion.vue?vue&type=script&lang=js&"
export * from "./admin_accordion.vue?vue&type=script&lang=js&"
import style0 from "./admin_accordion.vue?vue&type=style&index=0&id=0aab0efd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab0efd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aab0efd')) {
      api.createRecord('0aab0efd', component.options)
    } else {
      api.reload('0aab0efd', component.options)
    }
    module.hot.accept("./admin_accordion.vue?vue&type=template&id=0aab0efd&scoped=true&", function () {
      api.rerender('0aab0efd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/admin_accordion.vue"
export default component.exports